export const subscribeUrl = process.env.REACT_APP_SUBSCRIBE_URL as string;

export const googleChartsUrl = process.env.REACT_APP_GOOGLE_CHARTS_URL as string;
export const googleAnalyticsAppId = process.env.REACT_APP_GOOGLE_ANALYTICS_APP_ID as string;

export const recaptchaKey = process.env.REACT_APP_RECAPTCHA_KEY as string;
export const recaptchaUrlTemplate = process.env.REACT_APP_RECAPTCHA_URL_TEMPLATE as string;
